import { HardwareFeature, ColorTheme } from "./types";

export const colorTheme: ColorTheme = {
    blue: {
        gradient: "from-blue-400 to-blue-600",
        rgb: "59, 130, 246",
    },
    purple: {
        gradient: "from-purple-400 to-purple-600",
        rgb: "147, 51, 234",
    },
    teal: {
        gradient: "from-teal-400 to-teal-600",
        rgb: "20, 184, 166",
    },
    indigo: {
        gradient: "from-indigo-400 to-indigo-600",
        rgb: "99, 102, 241",
    },
    cyan: {
        gradient: "from-cyan-400 to-cyan-600",
        rgb: "6, 182, 212",
    },
    green: {
        gradient: "from-green-400 to-green-600",
        rgb: "34, 197, 94",
    },
    orange: {
        gradient: "from-orange-400 to-orange-600",
        rgb: "249, 115, 22",
    },
    red: {
        gradient: "from-red-400 to-red-600",
        rgb: "239, 68, 68",
    },
};

export const SmartBandhardwareFeatures: HardwareFeature[] = [
    {
        image: "/media/Hardware feature/band/Frame 66.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3",
        color: "orange",
    },
    {
        image: "/media/Hardware feature/band/Frame 63.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-2 md:col-start-1 md:row-start-4",
        color: "red",
    },
    {
        image: "/media/Hardware feature/band/Frame 53.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-5 md:col-start-5 md:row-start-1",
        color: "amber",
    },
    {
        image: "/media/Hardware feature/band/Frame 64.webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-9 md:row-start-1",
        color: "deepOrange",
    },
    {
        image: "/media/Hardware feature/band/Frame 59 .webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-11 md:row-start-1",
        color: "crimson",
    },
    {
        image: "/media/Hardware feature/band/Frame 67.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3 md:col-start-9 md:row-start-3",
        color: "sunset",
    },
];